import React from 'react'
import MaskedInput from 'react-text-mask'
export const CopyrightField = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput {...rest} mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]} placeholderChar={'\u2000'} />
  )
}

export default CopyrightField



// WEBPACK FOOTER //
// ./src/components/Fields/CopyrightField.js